import { useState } from 'react';
import { Container } from "./userMenuElements";
import { useNavigate } from "react-router-dom";
import {useDispatch, useSelector} from 'react-redux';
import { logout, selectUser, setActivePage } from "../../features/user/userSlice";
import { useCookies } from "react-cookie";
import MenuItems from "./MenuItems";
import { clearLimites } from '../../features/limitaciones/limitacionesSlice';
import axios from 'axios';
import { API_URL } from '../../const/api';

const UserMenu = ({showUserMenu, handleShowUserMenu, refer, isActiveImage}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [cookies, removeCookie] = useCookies(['user']);
  const usuario = useSelector(selectUser)

  const handleClick = (link) => {
		dispatch(setActivePage(link));
    handleShowUserMenu();
  }

  const exit = async () => {
    await axios.post(API_URL + "registroCerrarSesion",{usuario});
    removeCookie('MBA');
    removeCookie('MBB');
    //navigate('/');
    handleShowUserMenu();
    dispatch(logout({}));
    dispatch(clearLimites({}));
    window.location.href = '/';
  }
  
  return (
    <Container className={showUserMenu ? 'active' : null} ref={refer}>
      <MenuItems handleClick={handleClick} isActiveImage={isActiveImage} exit={exit} />
    </Container>
  )
}

export default UserMenu;